import React, { useState, useEffect, useRef } from 'react';
import { getImagePath } from '../config/siteConfig';
import '../styles/HeroSection.css';

const HeroSection = () => {
  const images = [
    {
      src: getImagePath('/assets/images/trips/heroSection/vecteezy_mountain-covered-in-clouds-under-cloudy-sky_46860434.jpeg'),
      alt: 'Mountain covered in clouds'
    },
    {
      src: getImagePath('/assets/images/trips/heroSection/vecteezy_snow-covered-tall-mountain-under-cloudy-sky_47024169.jpeg'),
      alt: 'Snow covered mountain'
    },
    {
      src: getImagePath('/assets/images/trips/heroSection/japan.jpg'),
      alt: 'Beautiful Japan landscape'
    },
    {
      src: getImagePath('/assets/images/trips/heroSection/nature-landscapes-background.jpg'),
      alt: 'Nature landscape'
    }
  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  // Handle touch/swipe for mobile
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null || touchStartY.current === null) return;

    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;

    const diffX = touchStartX.current - touchEndX;
    const diffY = touchStartY.current - touchEndY;

    // Only handle horizontal swipes (when X movement is greater than Y)
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
      if (diffX > 0) {
        // Swipe left - next image
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      } else {
        // Swipe right - previous image
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      }
    }

    touchStartX.current = null;
    touchStartY.current = null;
  };

  // Scroll to packages section when clicking "Discover the World"
  const handleDiscoverClick = () => {
    const packagesSection = document.getElementById('packages');
    if (packagesSection) {
      packagesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section 
      className="hero-modern" 
      id="home"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="hero-background">
        {images.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={image.alt}
            className={`hero-bg-image ${
              index === currentImageIndex ? 'active' : ''
            }`}
          />
        ))}
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content-wrapper">
        <div className="hero-text">
          <h1 className="hero-main-title">
            Explore the World and Create<br />
            Unforgettable Memories
          </h1>
          <p className="hero-subtitle">
            Book your travel and transportation service with us<br />
            and enjoy a hassle-free and memorable journey
          </p>
        </div>

        <button className="discover-btn" onClick={handleDiscoverClick}>
          Discover the World
        </button>
      </div>

      <div className="hero-indicators">
        {images.map((_, index) => (
          <button
            key={index}
            className={`indicator-dot ${
              index === currentImageIndex ? 'active' : ''
            }`}
            onClick={() => setCurrentImageIndex(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
